module.exports = __webpack_public_path__ + "img/ci.8c48118b.svg";